require("./brokerCryptoModalDocumentationHeader.scss");

// @vendors
import React from "react";
import PropTypes from "prop-types";
const { formatText } = require('core/i18n').i18n;

// @components
import { CryptoQuickButton } from "../../../brokerCryptoQuickButton/brokerCryptoQuickButton";

const CryptoModalDocumentationHeader = ({
    onClose,
    title,
    subtitle,
    onPrint,
    onDownload,
}) => (
    <div className="modal_documentation_header">
        <div className="modal_documentation_header__close-container">
            <button
                className="icon icon-cerrar modal_documentation_header__icon"
                onClick={onClose}
                aria-label="Close"
            />
        </div>
        <div className="modal_documentation_header__header">
            <div className="modal_documentation_header__left-content">
                <span className="modal_documentation_header__left-content-title">{title}</span>
                <span className="modal_documentation_header__left-content-subtitle">{subtitle}</span>
            </div>
            <div className="modal_documentation_header__right-content">
                <CryptoQuickButton
                    icon="imprimir"
                    label={formatText(
                        "brokerCryptoTest-documentationModalButtonPrint"
                    )}
                    onClick={onPrint}
                />
                <CryptoQuickButton
                    icon="descargar"
                    label={formatText(
                        "brokerCryptoTest-documentationModalButtonDownload"
                    )}
                    onClick={onDownload}
                />
            </div>
        </div>
    </div>
);

CryptoModalDocumentationHeader.propTypes = {
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    onPrint: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
};

CryptoModalDocumentationHeader.defaultProps = {
    subtitle: ""
};

export { CryptoModalDocumentationHeader };
